export const cloudProviderTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'cloudProviderName',
    header: 'Cloud Provider Name',
    className: 'cloud-provider-data-column',
    headerClassName: 'cloud-provider-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'cloud-provider-data-column',
    headerClassName: 'cloud-provider-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'cloud-provider-data-column cloud-provider-action-column',
    headerClassName: 'cloud-provider-data-column cloud-provider-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
];
